module.exports = __webpack_public_path__ + "static/img/img-home-service-01.aeb6ed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-service-01.png
// module id = 5JLN
// module chunks = 1